module.exports = __webpack_public_path__ + "img/icon-dropdown-expand.e8c7a94a.svg";